import React from 'react'
import styled from 'styled-components'
import { colors, breakpoints } from 'utils/utils'
import { FiChevronDown } from 'react-icons/fi'

export default props => {
    const goDown = () => {
        window.scroll({
            top: props.heroBottom - 70,
            behavior: 'smooth'
        });
    }
    return(
        <Container className={props.classArrow ? props.classArrow + ' scroll-down' : 'scroll-down'} onClick={goDown}>
            <FiChevronDown />
        </Container>
    )
}

const Container = styled.button`
    content: '';
    position: absolute;
    height: 3rem;
    width: 3rem;
    bottom: 3rem;
    left: 50%;
    z-index: 1;
    transform: translateX(-50%);
    padding: 0!important;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    

    @keyframes MoveUpDown {
        0%, 100% {
            top: 0;
        }
        50% {
            top: 50%;
        }
    }

    svg {
        background-color: ${colors.secondary}EE; 
        border: solid .1rem ${colors.senary};
        border-radius: 50%;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        animation: MoveUpDown 2s linear infinite;
    }

    &.hide {
        display: none;
    }

    ${breakpoints.md}{
        display: none;
    }
`